import { Box } from '@mui/material'
import React, { ReactNode, useEffect } from 'react'
import VenderHeader from './venderHeader';
import VenderMenue from './VenderMenue';
import { useSelector } from 'react-redux';
import { RootState } from '../../../Redux/store';
import { useNavigate } from 'react-router-dom';

interface MainLayoutProps {
    children: ReactNode;
}

function VenderLayout({ children }: MainLayoutProps) {

const {venderDetails} = useSelector((state:RootState)=>state.global)
const navigate = useNavigate()


useEffect(()=>{

    if(!venderDetails?.shopProfileId){
        navigate(-1)
    }
},[])
    return (
        <Box className='d-flex bg-black h-100 overflow-hidden gap-0 w-100'>
            <VenderMenue/>
            <Box sx={{flex:1, overflowX:'hidden !important'}}  className='d-flex  h-100 overflow-auto  flex-column'>
                <Box className='position-sticky top-0 w-100' sx={{ zIndex: 3 }}>
                    <VenderHeader />
                </Box>
                <Box className='bg-black' >
                    {children}
                </Box>
            </Box>
        </Box>
    )
}

export default VenderLayout
